// extracted by mini-css-extract-plugin
export default {"principal":"ContinuarProcessos_principal__rEPbQ","container":"ContinuarProcessos_container__NXE8N"};